export const newsLetterSubscription = (query) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          'access_token': query?.accessToken,
          'site_id': query?.site_id
        },
        body: JSON.stringify(query)
    };
    return fetch('/shared/api/newsSubscription', requestOptions).then((response) => response.json())
}


export const getSubscribedEmailList = (req) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json',
    'site_id': req?.site_id
    ,'access_token': req?.access_token
     },
  };
  return fetch('/shared/api/newsSubscriptionList', requestOptions).then((response)=>response.json())

}


export const removeSubscription = (query) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          'access_token': query?.accessToken,
          'site_id': query?.site_id
        },
        body: JSON.stringify(query)
    };
    return fetch('/shared/api/removeNewsSubscription', requestOptions).then((response) => response.json())
}